import Vue from 'vue';
import '../scss/styles.scss';
import { DataConceptItem } from '../models/DataConceptItem';

export default Vue.extend({
  name: 'dataitem',
  props: {
    items: {
      type: Array as () => DataConceptItem[],
      required: true,
    },
  },
  methods: {
    go() {},
  },
  data() {
    return {
    };
  },
});
